import { render, staticRenderFns } from "./deailDialog.vue?vue&type=template&id=770b0e1f&scoped=true"
import script from "./deailDialog.vue?vue&type=script&lang=js"
export * from "./deailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b0e1f",
  null
  
)

export default component.exports